<template>
  <div @mouseover="show = true" @mouseleave="show = false" class="relative inline:block">
    <slot />
  </div>
  <div v-if="show" class="center absolute left-9 z-10">
    <span class="bg-yellow-200 whitespace-pre">{{ msg }}</span>
  </div>
</template>


<script>
export default {
  props: { 
    msg: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      show: false
    }
  }
};
</script>
